import React from "react";

const TreatmentPlan = ({ formData, handleChange, setActiveTab, errors = {} }) => {
    const options = [
        { value: "initiate_medications", label: "Initiate medications at home" },
        { value: "continue_current", label: "Continue current medications" },
        { value: "refer_trh_outpatient", label: "Refer to TRH out-patient" },
        { value: "appropriate_trh_residential", label: "Appropriate for TRH-RRP" },
        { value: "appropriate_drp", label: "Appropriate for TRH-DRP" },
        { value: "refer_other", label: "Refer to any other service" }
    ];

    return (
        <div id="treatment-plan" className="content">
            {/* Sticky Guidelines Button */}
            <div className="row mb-4 position-sticky top-0 bg-white pt-3" style={{ zIndex: 10 }}>
                <div className="col-md-3">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm w-100"
                        data-bs-toggle="modal"
                        data-bs-target="#treatmentGuidelines"
                    >
                        <i className="ri-information-line me-2"></i>
                        Guidelines
                    </button>
                </div>
            </div>
            <div className="p-3" style={{ maxHeight: "60vh", overflowY: "auto", scrollbarWidth: "thin" }}>

                {/* SECTION: Treatment Plan */}
                <div className="col-md-12">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                        Treatment Plan
                    </small>

                    <div className="row">
                        {options.map((opt) => {
                            const id = `treat_${opt.value}`;
                            return (
                                <div className="col-md-6 mb-2" key={opt.value}>
                                    <div className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="treatmentOption"
                                            id={id}
                                            value={opt.value}
                                            checked={formData.treatmentOption === opt.value}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor={id}>
                                            {opt.label}
                                        </label>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    {errors.treatmentOption && (
                        <small className="text-danger d-block mt-2">{errors.treatmentOption}</small>
                    )}
                </div>

                {/* SECTION: Reason */}
                <div className="col-md-12 mt-3">
                    <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-2">
                        Reason for Selected Treatment Plan
                    </small>

                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control ${errors.reason ? 'is-invalid' : ''}`}
                            name="reason"
                            rows="4"
                            style={{ height: "120px" }}
                            value={formData.reason || ""}
                            onChange={handleChange}
                        ></textarea>
                        <label>Reason</label>
                        {errors.reason && (
                            <div className="invalid-feedback">{errors.reason}</div>
                        )}
                    </div>
                </div>

                {/* Buttons */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm btn-prev w-100"
                            onClick={() => setActiveTab("client-behavior")}
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="submit"
                            className="btn btn-primary btn-sm ms-2 w-100"
                        >
                            Submit <i className="ri-check-line"></i>
                        </button>
                    </div>
                </div>
            </div>
            {/* Guidelines Modal */}
            <div className="modal fade" id="treatmentGuidelines" tabIndex="-1">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">

                            <h5>Subsequent Home Visits</h5>

                            {/* 1st Visit */}
                            <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                1st Visit: one hour visit
                            </small>
                            <ul>
                                <li>30minutes for family psychoeducation of the care giver and "Engagement"</li>
                                <li>30 minutes for client's initial assessment of condition, determine need & readiness for medication.</li>
                            </ul>

                            {/* 2nd Visit */}
                            <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                2nd Visit: one hour visit
                            </small>
                            <ul>
                                <li>30minutes for family psychoeducation</li>
                                <li>30 minutes for in-depth assessment of client's condition & Response to medication if it had been prescribed on previous medication.</li>
                            </ul>

                            <p>Institute changes or continues medication based on findings.</p>

                            {/* 3rd Visit */}
                            <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                3rd Visit: one hour visit
                            </small>
                            <ul>
                                <li>Problem-solving session as part of Family Psych education with care giver & client.</li>
                                <li>Assessment for Rehabilitation readiness & Initial Goal setting conversation</li>
                            </ul>

                            {/* 4th Visit */}
                            <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                4th Visit: one hour visit
                            </small>
                            <ul>
                                <li>Decision making session; Working with Client to determine client's willingness for psychiatric Rehabilitation as a Residential or day program participant.</li>
                                <li>Educating Client on what he/she could expect from an individualized Rehabilitation Plan. Allow client to share his/her understanding, expectations, or reservations of either plan.</li>
                                <li>The meeting ends with a decision for future management plan and home services are terminated.</li>
                            </ul>

                            <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                                Time slots allocated for Home Visits:
                            </small>
                            <p>In the beginning two to three visits per week. Then can increase to up to three full days per week.</p>

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-outline-primary" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TreatmentPlan;